module.exports = __webpack_public_path__ + "5823819bdf318e17cc8e2e84be15fa01.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/banjo.png
// module id = 2819
// module chunks = 0